<template>
  <ConfigProvider :locale="getAntdLocale">
    <template #renderEmpty>
      <section class="flex flex-col justify-center items-center">
        <SvgIcon name="no_data" size="100" />
        <span>{{ t('component.table.noData') }}</span>
      </section>
    </template>
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import { useLocale } from '@mcex/locale';
  import { ConfigProvider } from 'ant-design-vue';
  import { AppProvider } from '/@/components/Application';
  import { SvgIcon } from '/@/components/Icon';
  import { useTitle } from '/@/hooks/web/useTitle';

  import { useMaintenance } from '@mcex/hooks';
  import 'dayjs/locale/zh-cn';
  import { onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { useInitSysSetting } from './hooks/sys/useInitSysSetting';
  import { useResizeScale } from './hooks/sys/useResizeScale';
  import { useI18n } from './hooks/web/useI18n';
  import { useRefreshToken } from '/@/hooks/sys/useRefreshToken';
  import { useAppStoreWithOut } from '/@/store/modules/app';
  import { useCheckNetwork } from './hooks/sys/useCheckNetwork';
  import { useFireFoxStyle } from './hooks/web/useFireFoxStyle';
  import { useNotification } from './hooks/sys/useNotification';

  //import { useKeyboardFixH5 } from './hooks/sys/useKeyboardFixH5';

  // support Multi-language
  const { getAntdLocale } = useLocale();
  const { t } = useI18n();
  const router = useRouter();
  // Listening to page changes and dynamically changing site titles
  useTitle();
  useRefreshToken();
  useMaintenance(router, useAppStoreWithOut);
  useResizeScale();

  useInitSysSetting();
  useCheckNetwork();
  useFireFoxStyle();

  useNotification();

  onMounted(() => {
    setTimeout(() => {
      const sensors = window['sensorsDataAnalytic201505'];
      sensors?.quick('autoTrack', {});
    }, 301);
  });
</script>
